module.exports = __webpack_public_path__ + "files/673ca72c573b4d787e4c70b9f4416e90.png";